import { useSubscriptionOfferWithdraw as useSubscriptionOfferWithdrawMutation } from "@/api";
import { useToast } from "@/components/ui/use-toast";

export function useSubscriptionOfferWithdraw(subscriptionOfferId: string) {
  const [subscriptionOfferWithdraw] =
    useSubscriptionOfferWithdrawMutation(subscriptionOfferId);
  const { toast } = useToast();

  function handleError(desc?: string) {
    toast({
      title: "Unable to withdraw subscription offer",
      description:
        desc ||
        "An error occurred while withdrawing the subscription offer. Please try again or report the issue."
    });
  }

  function handleSubscriptionOfferWithdraw() {
    subscriptionOfferWithdraw()
      .then((res) => {
        const typename = res.data?.subscriptionOfferWithdraw.__typename;
        if (res.errors?.length) {
          console.error(
            "subscriptionOfferWithdraw GraphQL errors:",
            res.errors
          );
          handleError();
        }
        if (!typename || typename === "SubscriptionOfferNotFound")
          handleError();
        else if (typename === "SubscriptionOfferInvalidStatus") {
          handleError(
            "The offer is in a state where it cannot be withdrawn. This means it has already been withdrawn, accepted or rejected."
          );
        } else if (typename === "SubscriptionOffer") {
          toast({
            title: "Subscription offer withdrawn",
            description:
              "The subscription offer has been withdrawn and can no longer be accessed by the receiver."
          });
        }
      })
      .catch((error) => {
        console.error("subscriptionOfferWithdraw error:", error);
        handleError();
      });
  }

  return { handleSubscriptionOfferWithdraw };
}
